export const categoryArticles = [
  {
    id: 'cat-art-1',
    title: '千万粉丝女主播直播间假哭求打赏，网友怒扒其豪宅名表',
    summary: '平时在直播间里以"底层打工人"人设示人的知名女主播，被网友扒出名下拥有多套豪宅及限量名表，直播间痛哭流涕的桥段实为剧本...',
    category: '黑料爆料',
    slug: 'nuzhubo-jiaku-qiudashang',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20photograph%20with%20warm%20muted%20tones%2C%20featuring%20an%20abstract%20luxury%20lifestyle%20scene%20with%20subtle%20hints%20of%20expensive%20watches%20and%20elegant%20interiors%20reflected%20in%20glass%20surfaces%2C%20soft%20cream%20and%20beige%20color%20palette%2C%20sophisticated%20magazine%20editorial%20aesthetic&width=600&height=420&seq=cat-art-01&orientation=landscape',
    date: '2026-07-07',
    views: 864000,
    readTime: '5分钟',
    author: '吃瓜小编',
    tags: ['直播', '人设崩塌', '假哭'],
  },
  {
    id: 'cat-art-2',
    title: '选秀C位出道后资源全面崩盘，昔日队友爆料其私下耍大牌',
    summary: '凭借选秀节目C位出道的男艺人，出道后不仅未如预期般爆红，反而资源全面崩盘。昔日队友在直播中无意中爆料...',
    category: '黑料爆料',
    slug: 'cwei-daodao-ziyuan-bengpan',
    image: 'https://readdy.ai/api/search-image?query=A%20moody%20editorial%20photograph%20with%20warm%20golden%20lighting%2C%20featuring%20an%20abstract%20backstage%20talent%20show%20scene%20with%20stage%20lights%20and%20drama%20masks%2C%20muted%20cream%20and%20amber%20color%20palette%2C%20cinematic%20magazine%20aesthetic&width=600&height=420&seq=cat-art-02&orientation=landscape',
    date: '2026-07-06',
    views: 723000,
    readTime: '4分钟',
    author: '爆料君',
    tags: ['选秀', '艺人', '耍大牌'],
  },
  {
    id: 'cat-art-3',
    title: '某顶流男星被曝同时交往多位女友，时间管理大师再添一人',
    summary: '娱乐圈"时间管理大师"疑似再添新成员。某顶流男星被多位女生同时爆料，称其在同一时间段内与多名女性保持恋爱关系...',
    category: '黑料爆料',
    slug: 'dingliu-nanxing-duoweinuyou',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20editorial%20photograph%20with%20warm%20lighting%20and%20deep%20shadows%2C%20featuring%20an%20abstract%20romantic%20scene%20with%20blurred%20city%20night%20lights%20and%20silhouettes%2C%20muted%20cream%20and%20beige%20color%20palette%2C%20sophisticated%20magazine%20editorial%20style&width=600&height=420&seq=cat-art-03&orientation=landscape',
    date: '2026-07-05',
    views: 1560000,
    readTime: '6分钟',
    author: '八卦先锋',
    tags: ['恋情', '劈腿', '顶流'],
  },
  {
    id: 'cat-art-4',
    title: '带货主播直播间售假被实锤，消费者集体维权起诉',
    summary: '某头部带货主播在直播间售卖所谓"专柜正品"奢侈品包，多名消费者购买后发现为仿品，目前已有多位消费者联合维权...',
    category: '黑料爆料',
    slug: 'daihuo-zhubo-shoujia-shichui',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20photograph%20with%20warm%20ambient%20lighting%2C%20featuring%20an%20abstract%20e-commerce%20livestream%20scene%20with%20products%20and%20packaging%20boxes%20scattered%20in%20a%20minimalist%20studio%20setting%2C%20cream%20and%20warm%20gray%20color%20palette%2C%20sophisticated%20magazine%20aesthetic&width=600&height=420&seq=cat-art-04&orientation=landscape',
    date: '2026-07-04',
    views: 534000,
    readTime: '4分钟',
    author: '正义使者',
    tags: ['带货', '假货', '维权'],
  },
  {
    id: 'cat-art-5',
    title: '短剧一哥人设彻底崩塌，合作导演怒斥其片场耍大牌',
    summary: '凭借爆款短剧走红的男演员，近期被合作导演发文指责其在片场态度恶劣、多次迟到，甚至要求全组人员配合其作息...',
    category: '网红塌房',
    slug: 'duanju-yige-renshe-bengta',
    image: 'https://readdy.ai/api/search-image?query=A%20moody%20editorial%20photograph%20with%20warm%20lighting%20and%20dramatic%20shadows%2C%20featuring%20an%20abstract%20film%20set%20scene%20with%20director%20chair%20and%20clapperboard%2C%20muted%20cream%20and%20beige%20color%20palette%2C%20cinematic%20magazine%20editorial%20style&width=600&height=420&seq=cat-art-05&orientation=landscape',
    date: '2026-07-07',
    views: 892000,
    readTime: '5分钟',
    author: '片场爆料人',
    tags: ['短剧', '片场', '耍大牌'],
  },
  {
    id: 'cat-art-6',
    title: '百万粉美妆博主翻车了，被曝长期使用美颜滤镜欺骗粉丝',
    summary: '一直以"素颜化妆教程"走红的百万粉美妆博主，近日被网友扒出所有素颜视频均经过重度美颜处理，真实素颜状态与视频中判若两人...',
    category: '网红塌房',
    slug: 'meizhuang-bozhu-meiyan-qipian',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20editorial%20photograph%20with%20soft%20lighting%2C%20featuring%20an%20abstract%20beauty%20studio%20scene%20with%20makeup%20brushes%20and%20mirrors%20reflecting%20soft%20light%2C%20muted%20cream%20and%20beige%20color%20palette%2C%20sophisticated%20magazine%20editorial%20aesthetic&width=600&height=420&seq=cat-art-06&orientation=landscape',
    date: '2026-07-06',
    views: 678000,
    readTime: '4分钟',
    author: '美妆侦探',
    tags: ['美妆', '滤镜', '翻车'],
  },
  {
    id: 'cat-art-7',
    title: '电竞选手被爆比赛中开挂，战队紧急宣布暂停其所有合约',
    summary: '某知名电竞战队核心选手被多名对手及解说质疑在比赛中使用外挂程序，战队于今日凌晨发布声明，宣布暂停该选手所有比赛合约...',
    category: '电竞圈',
    slug: 'dianjing-xuanshou-kaigua',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20editorial%20photograph%20with%20warm%20lighting%20and%20dramatic%20shadows%2C%20featuring%20an%20abstract%20esports%20arena%20scene%20with%20gaming%20setup%20and%20headset%20silhouettes%2C%20muted%20cream%20and%20dark%20gray%20color%20palette%2C%20sophisticated%20magazine%20editorial%20aesthetic&width=600&height=420&seq=cat-art-07&orientation=landscape',
    date: '2026-07-05',
    views: 445000,
    readTime: '3分钟',
    author: '电竞观察员',
    tags: ['电竞', '开挂', '战队'],
  },
  {
    id: 'cat-art-8',
    title: '娱乐圈某夫妇被曝早已分居，合体营业仅为维持商业价值',
    summary: '圈内知情人士透露，某明星夫妇虽然经常在社交平台和公开场合秀恩爱，实则早已分居，目前的合体营业仅为维持品牌代言和商业价值...',
    category: '娱乐圈',
    slug: 'mingxing-fufu-fenju-heyin',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20photograph%20with%20warm%20lighting%20and%20deep%20shadows%2C%20featuring%20an%20abstract%20red%20carpet%20scene%20with%20blurred%20couple%20silhouettes%20and%20flash%20lights%2C%20muted%20cream%20and%20beige%20color%20palette%2C%20cinematic%20magazine%20aesthetic&width=600&height=420&seq=cat-art-08&orientation=landscape',
    date: '2026-07-04',
    views: 1120000,
    readTime: '5分钟',
    author: '圈内人',
    tags: ['明星夫妇', '分居', '假恩爱'],
  },
  {
    id: 'cat-art-9',
    title: '吃瓜视频精选：年度十大翻车现场盘点',
    summary: '回顾2026年上半年，我们精选了十大最令人瞠目的翻车名场面，从直播间口不择言到人设崩塌现场，一次看个够...',
    category: '吃瓜视频',
    slug: 'nianfen-qianda-fanche-pandian',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20editorial%20photograph%20with%20soft%20lighting%2C%20featuring%20an%20abstract%20video%20editing%20scene%20with%20monitor%20screens%20and%20timeline%20interface%2C%20muted%20cream%20and%20beige%20color%20palette%2C%20sophisticated%20magazine%20editorial%20aesthetic&width=600&height=420&seq=cat-art-09&orientation=landscape',
    date: '2026-07-03',
    views: 2340000,
    readTime: '8分钟',
    author: '视频精选',
    tags: ['盘点', '翻车', '名场面'],
  },
  {
    id: 'cat-art-10',
    title: '某直播公会老板被曝压榨旗下主播，抽成高达七成',
    summary: '多名前签约主播联合发声，称某头部直播公会老板不仅抽成比例高达70%，还要求主播签署多项不平等条款...',
    category: '直播圈',
    slug: 'gonghuilaoban-yazha-zhubo',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20photograph%20with%20warm%20lighting%20and%20soft%20contrast%2C%20featuring%20an%20abstract%20corporate%20office%20meeting%20room%20scene%20with%20contracts%20and%20documents%20on%20a%20glass%20table%2C%20muted%20cream%20and%20warm%20gray%20color%20palette%2C%20sophisticated%20magazine%20editorial%20style&width=600&height=420&seq=cat-art-10&orientation=landscape',
    date: '2026-07-02',
    views: 387000,
    readTime: '4分钟',
    author: '维权之声',
    tags: ['直播公会', '压榨', '不平等'],
  },
];

export const articleDetail = {
  id: 'detail-1',
  title: '千万粉丝女主播直播间假哭求打赏，网友怒扒其豪宅名表',
  slug: 'nuzhubo-jiaku-qiudashang',
  category: '黑料爆料',
  author: '吃瓜小编',
  authorAvatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20abstract%20avatar%20portrait%20with%20warm%20tones%20on%20a%20solid%20cream%20background%2C%20geometric%20shape%20inspired%20face%2C%20soft%20shadows%2C%20clean%20modern%20editorial%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
  date: '2026-07-07',
  updatedAt: '2026-07-07 18:30',
  views: 864000,
  readTime: '5分钟',
  image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20editorial%20photograph%20with%20warm%20muted%20tones%2C%20featuring%20an%20abstract%20livestream%20broadcasting%20studio%20scene%20with%20ring%20light%20and%20microphone%20equipment%20in%20soft%20focus%2C%20subtle%20hints%20of%20luxury%20items%20reflected%20in%20glass%2C%20cream%20and%20warm%20beige%20color%20palette%2C%20sophisticated%20magazine%20editorial%20aesthetic%20with%20soft%20dramatic%20lighting&width=1200&height=680&seq=article-hero-01&orientation=landscape',
  content: [
    {
      type: 'paragraph',
      text: '近日，一位在短视频平台拥有超过千万粉丝的知名女主播"小甜甜"彻底翻车了。这位平时在直播间里以"底层打工人"、"打工人不易"人设示人的主播，被网友扒出名下实际拥有多套豪宅及多块限量名表，直播间里痛哭流涕求打赏的桥段，被证实为团队精心策划的剧本。',
    },
    {
      type: 'paragraph',
      text: '事件起因是一位眼尖的网友发现，在某张疑似"小甜甜"的社交照片中，她佩戴的一块腕表价值超过60万元。随后，更多细节被网友逐一扒出：她所谓的"租来的小公寓"实际上是位于市中心的一套300平米大平层，而她口中"省吃俭用攒下的存款"更是被扒出远超普通人的想象。',
    },
    {
      type: 'heading',
      text: '直播间里的"苦情戏"',
    },
    {
      type: 'paragraph',
      text: '据悉，"小甜甜"的直播间经常会上演一出出精心编排的"苦情戏"。有时是哭诉工作压力大，有时是讲述童年苦难经历，每次都能成功引发粉丝的同情心，直播间礼物打赏量也会随之飙升。',
    },
    {
      type: 'paragraph',
      text: '有粉丝透露，自己曾多次在"小甜甜"的哭穷直播中被感动，累计打赏超过两万元。得知真相后，该粉丝表示"感觉像被当成了傻子，以后再也不会给任何主播打赏了"。',
    },
    {
      type: 'heading',
      text: '豪宅名表背后的真实生活',
    },
    {
      type: 'paragraph',
      text: '网友扒出的信息显示，"小甜甜"名下的房产不仅包括一套市中心的豪华大平层，还在某热门旅游城市拥有一套度假别墅。而她日常佩戴的饰品中，不乏卡地亚、梵克雅宝等奢侈品牌，与她直播中塑造的"打工人"形象完全不符。',
    },
    {
      type: 'paragraph',
      text: '更让人震惊的是，有前团队成员爆料，"小甜甜"每次直播前都会与团队开会讨论当天的"剧情脚本"，甚至连"动情落泪"的节点都会精确到分钟。直播间里那些看起来真情实感的互动，实则都是团队反复排练的结果。',
    },
    {
      type: 'heading',
      text: '行业乱象引发广泛讨论',
    },
    {
      type: 'paragraph',
      text: '"小甜甜"事件曝光后，引发了网友对于直播行业乱象的广泛讨论。许多人表示，类似的"哭穷"剧本在各大直播平台屡见不鲜，利用粉丝的同情心赚取打赏已经成为某些主播的标准套路。',
    },
    {
      type: 'paragraph',
      text: '截至目前，"小甜甜"尚未对此次事件作出正面回应。但其社交媒体账号已关闭评论功能，粉丝数量也在持续下降中。据悉，已有多个与她合作的品牌方宣布暂停合作。',
    },
  ],
  tags: ['直播', '人设崩塌', '假哭', '豪宅', '名表'],
};

export const relatedArticles = [
  {
    id: 'rel-1',
    title: '百万粉美妆博主翻车了，被曝长期使用美颜滤镜欺骗粉丝',
    slug: 'meizhuang-bozhu-meiyan-qipian',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20editorial%20photograph%20with%20soft%20lighting%2C%20featuring%20an%20abstract%20beauty%20studio%20scene%20with%20makeup%20brushes%20and%20mirrors%20reflecting%20soft%20light%2C%20muted%20cream%20and%20beige%20color%20palette%2C%20sophisticated%20magazine%20editorial%20aesthetic&width=400&height=280&seq=rel-art-01&orientation=landscape',
    views: 678000,
    date: '2026-07-06',
  },
  {
    id: 'rel-2',
    title: '某直播公会老板被曝压榨旗下主播，抽成高达七成',
    slug: 'gonghuilaoban-yazha-zhubo',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20photograph%20with%20warm%20lighting%20and%20soft%20contrast%2C%20featuring%20an%20abstract%20corporate%20office%20meeting%20room%20scene%20with%20contracts%20and%20documents%20on%20a%20glass%20table%2C%20muted%20cream%20and%20warm%20gray%20color%20palette%2C%20sophisticated%20magazine%20editorial%20style&width=400&height=280&seq=rel-art-02&orientation=landscape',
    views: 387000,
    date: '2026-07-02',
  },
  {
    id: 'rel-3',
    title: '带货主播直播间售假被实锤，消费者集体维权起诉',
    slug: 'daihuo-zhubo-shoujia-shichui',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20photograph%20with%20warm%20ambient%20lighting%2C%20featuring%20an%20abstract%20e-commerce%20livestream%20scene%20with%20products%20and%20packaging%20boxes%20scattered%20in%20a%20minimalist%20studio%20setting%2C%20cream%20and%20warm%20gray%20color%20palette%2C%20sophisticated%20magazine%20aesthetic&width=400&height=280&seq=rel-art-03&orientation=landscape',
    views: 534000,
    date: '2026-07-04',
  },
];

export const comments = [
  {
    id: 'c1',
    name: '吃瓜群众A',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20abstract%20avatar%20portrait%20with%20warm%20tones%20on%20a%20solid%20cream%20background%2C%20geometric%20shape%20inspired%20face%2C%20soft%20shadows%2C%20clean%20modern%20editorial%20style&width=60&height=60&seq=comment-avatar-01&orientation=squarish',
    content: '早就觉得她不对劲了，天天在直播间哭穷，结果一看座驾是保时捷，真是戏精附体。',
    time: '2小时前',
    likes: 2341,
  },
  {
    id: 'c2',
    name: '理性看客',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20abstract%20avatar%20portrait%20with%20warm%20tones%20on%20a%20solid%20cream%20background%2C%20geometric%20shape%20inspired%20face%2C%20soft%20shadows%2C%20clean%20modern%20editorial%20style&width=60&height=60&seq=comment-avatar-02&orientation=squarish',
    content: '说实话，主播利用人设赚钱是行业常态，但是装穷骗打赏就有点过分了。还是希望平台能加强监管。',
    time: '4小时前',
    likes: 1876,
  },
  {
    id: 'c3',
    name: '被骗的榜一大哥',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20abstract%20avatar%20portrait%20with%20warm%20tones%20on%20a%20solid%20cream%20background%2C%20geometric%20shape%20inspired%20face%2C%20soft%20shadows%2C%20clean%20modern%20editorial%20style&width=60&height=60&seq=comment-avatar-03&orientation=squarish',
    content: '之前给她刷了五万多，现在想想真是个冤大头。能不能要求退款？',
    time: '5小时前',
    likes: 3420,
  },
];

export const faqData = {
  mainEntity: [
    {
      question: '吃瓜网在线是什么平台？',
      answer: '吃瓜网在线是一个专注于聚合网红塌房事件、黑料爆料、吃瓜视频等娱乐八卦内容的媒体资讯平台。我们致力于为用户提供最新、最全面的在线吃瓜体验，实时追踪娱乐圈、网红圈、直播圈、电竞圈的热门事件。',
    },
    {
      question: '吃瓜网在线上的内容真实吗？',
      answer: '吃瓜网在线平台上的所有内容均来自公开渠道和网络爆料，仅供娱乐参考。我们不对内容的绝对真实性作出保证，建议用户保持理性态度，自行判断信息的可信度。如有不实信息，欢迎联系我们核实处理。',
    },
    {
      question: '如何在吃瓜网在线投稿爆料？',
      answer: '如果您有独家爆料信息想要分享，可以通过页面导航栏的"爆料投稿"按钮或关于我们页面的联系方式与我们取得联系。我们会核实信息来源后，决定是否发布。请注意，我们只接受有可靠来源的爆料，严禁发布诽谤和虚假信息。',
    },
    {
      question: '吃瓜网在线是否收取费用？',
      answer: '吃瓜网在线目前完全免费向所有用户开放。您可以免费浏览所有爆料内容、观看吃瓜视频、追踪网红塌房事件。我们可能会在未来推出一些增值服务，但基础内容将始终免费开放。',
    },
  ],
};

export function getArticlesByCategory(category: string) {
  return categoryArticles.filter(a => a.category === category || category === '全部');
}

export function getCategoryInfo(category: string) {
  const count = getArticlesByCategory(category).length;
  const descriptions: Record<string, string> = {
    '黑料爆料': '最新最热的明星网红黑料爆料，第一时间掌握娱乐圈、网红圈不为人知的一面',
    '网红塌房': '实时追踪各大网红塌房事件，完整时间线复盘，看网红从巅峰到谷底的全过程',
    '吃瓜视频': '精选热门爆料视频，视频还原事件真相，让你身临其境感受吃瓜现场',
    '娱乐圈': '聚焦明星艺人的八卦动态，从恋情曝光到出轨丑闻，一个不落',
    '直播圈': '关注直播行业内幕，主播互撕、公会纠纷、打赏套路，带你走进直播的B面',
    '电竞圈': '电竞选手、战队八卦、比赛黑幕，满足电竞爱好者的吃瓜需求',
  };
  return {
    name: category,
    description: descriptions[category] || '浏览该分类下的所有爆料内容',
    count,
  };
}